import React, { useState, useRef, useEffect } from "react";
import { SlRefresh } from "react-icons/sl";
import { FaChevronRight } from "react-icons/fa";
import { MdOutlineEventNote } from "react-icons/md";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../gif/loader.gif";
import { BsUpcScan } from "react-icons/bs";
import { FaChartLine } from "react-icons/fa6";

function EventComp() {
  const contentRef = useRef(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState([]);

  const reloadEvents = () => {
    loadEvents();
  };

  // Function to scroll down on button click
  const handleScrollRight = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({
        left: 200, // Adjust this value based on how much you want to scroll
        behavior: "smooth",
      });
    }
  };
  const loadEvents = async () => {
    setLoading(!loading);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-upcoming`
      );
      let retcode = res.data;
      setEvents(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get calendar events error =>" + error);
    }
  };
  useEffect(() => {
    // Fetch events or load from a source (e.g., API)
    loadEvents();
  }, []);
  return (
    <div className="row">
      <div className="row">
        <div className="col-md-10"></div>
        <div className="col-md-1 text-end mt-1">
          <button
            className="border-0"
            onClick={reloadEvents}
            style={{ textAlign: "end" }}
          >
            <SlRefresh size={25} />
          </button>
        </div>
        <div className="col-md-1 text-end">
          <button
            className="bg-info p-2"
            onClick={handleScrollRight}
            style={{
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
      {/* Container to hold the horizontally sliced content */}
      <div
        className="col-md-8 p-3 shadow"
        ref={contentRef}
        style={{
          display: "flex", // Arrange items in a row
          overflowX: "auto", // Enable horizontal scrolling
          whiteSpace: "nowrap", // Prevent line breaks between items
          padding: "20px",
          width: "100%", // Visible width of the container
          borderRadius: 15,
        }}
      >
        {/* Horizontally sliced content */}
        {loading ? (
          <img
            src={Loader}
            style={{ alignSelf: "center" }}
            alt="QR Code"
            width={"50"}
            height={"50"}
          />
        ) : (
          events.map((item, index) => {
            return (
              <div
                key={index}
                className="m-2 shadow p-3"
                style={{ minWidth: "60%", height: "200px", borderRadius: 10 }}
              >
                <div className="row">
                  <p
                    style={{
                      textTransform: "uppercase",
                      fontWeight: "bold",
                      fontSize: 13,
                    }}
                  >
                    {item.title}
                  </p>

                  <hr className="w-75" />
                  <div className="row">
                    <div className="col-md-3">
                      <p className="m-0">
                        <small>status</small>
                      </p>
                      <p className="m-0">
                        <small>Start date</small>
                      </p>
                      <p className="m-0">
                        <small>expiry date</small>
                      </p>
                    </div>
                    <div className="col-md-4">
                      <small>
                        {new Date().setHours(0, 0, 0, 0) <
                        new Date(item.date).setHours(0, 0, 0, 0) ? (
                          <small className="badge bg-success">upcoming</small>
                        ) : new Date().setHours(0, 0, 0, 0) >=
                            new Date(item.date).setHours(0, 0, 0, 0) &&
                          new Date().setHours(0, 0, 0, 0) <=
                            new Date(item.expiry).setHours(0, 0, 0, 0) ? (
                          <small className="badge bg-info">in prigress</small>
                        ) : (
                          <small className="badge bg-danger">
                            event passed
                          </small>
                        )}
                      </small>
                      <p
                        className="m-0"
                        style={{
                          fontSize: 15,
                          fontStyle: "italic",
                          fontWeight: "bold",
                        }}
                      >
                        <small className="text-success">{item.date}</small>
                      </p>
                      <small className="text-info">{item.expiry}</small>
                    </div>
                    <div className="col-md-4 text-start">
                      <Link
                        to="#"
                        className="p-3 w-100 text-dark bg-light bg-gradient"
                        type="submit"
                        style={{
                          border: "none",
                          fontWeight: "bold",
                          fontSize: 12,
                        }}
                      >
                        <FaChartLine className="me-2" size={20} /> REPORT
                      </Link>
                    </div>
                  </div>
                  <div className="row text-center">
                    {new Date().setHours(0, 0, 0, 0) ===
                      new Date(item.date).setHours(0, 0, 0, 0) &&
                    new Date().setHours(0, 0, 0, 0) <=
                      new Date(item.expiry).setHours(0, 0, 0, 0) ? (
                      <Link
                        to={`/scan/${item.title}`}
                        className="p-3 w-100 text-dark ml-2"
                        style={{
                          backgroundColor: "#3bc0c3",
                          border: "none",
                          fontWeight: "bold",
                          fontSize: 14,
                        }}
                      >
                        <BsUpcScan className="me-2" size={20} />
                        MARK REGISTER
                      </Link>
                    ) : null}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
      <div className="col-md-4"></div>
      {/* Button to scroll forward */}
    </div>
  );
}
export default EventComp;
